import { AxiosResponse } from 'axios'
import { generalServiceV1API, magnoliaServiceAPI } from '@/store/api-instance'
import { IReportingRequest } from '@/store/modules/reporting/interfaces/api/IReportingRequest'
import { IReportingAxiosResponse, IReportingResponse, ITokenData } from '@/store/modules/reporting/interfaces/api/IReportingResponse'

export const reportingAPI = {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  async getPowerBIDetails (dto: IReportingRequest): Promise<ITokenData> {
    const response: AxiosResponse = (await magnoliaServiceAPI.get(
      '/reports/GetReportEmbededConfig',
      { params: dto }
    )) as AxiosResponse<IReportingResponse>
    return response.data
  },
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  async getContractsPowerBIDetails (dto: IReportingRequest): Promise<IReportingResponse> {
    const response: AxiosResponse<IReportingResponse> = (await generalServiceV1API.get(
      '/power-bi/contract-evaluation'
    )) as AxiosResponse<IReportingResponse>
    return response.data
  },
  async getReports (dto: IReportingRequest): Promise<IReportingAxiosResponse> {
    const response: AxiosResponse<IReportingAxiosResponse> = (await magnoliaServiceAPI.get(
      '/reports/GetAllReports',
      { params: dto }
    )) as AxiosResponse<IReportingAxiosResponse>

    return response.data
  }
}
